import { useTranslations } from "@jugl-web/utils";
import { LoadingSpinner } from "@jugl-web/ui-kit";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import { Header } from "./components/Header/Header";
import { useBoardTemplatesModalProvider } from "../../providers/useBoardTemplatesModalProvider";
import { useBoardTemplates } from "../../hooks/useBoardTemplates";
import { BoardTemplatesCard } from "./components/BoardTemplatesCard/BoardTemplatesCard";
import { BoardTemplateDetails } from "../BoardTemplateDetails/BoardTemplateDetails";

export const BoardCategoryTemplatesList = () => {
  const { selectedCategory, selectedTemplate, searchQuery } =
    useBoardTemplatesModalProvider();
  const { templates, isLoadingMore, loadMore, isLoading, hasMore } =
    useBoardTemplates({
      category: selectedCategory,
      searchQuery,
    });
  const { t } = useTranslations();
  const noSearchResults = templates?.length === 0 && searchQuery;

  const { ref: loadMoreRef, inView: loadMoreInView } = useInView();
  useEffect(() => {
    if (isLoading || isLoadingMore || !loadMoreInView || !hasMore) {
      return;
    }
    loadMore();
  }, [loadMoreInView, loadMore, isLoading, isLoadingMore, hasMore]);
  return (
    <div className="flex w-full flex-col">
      {!selectedTemplate && <Header />}
      {!selectedTemplate && (
        <div className="flex flex-wrap gap-6 px-10 py-8">
          {noSearchResults && (
            <div className="w-full text-center text-dark-700">
              {t({
                id: "board-templates.no-results",
                defaultMessage: "No templates found",
              })}
            </div>
          )}
          {templates?.map((template) => (
            <div key={template.id} className="shrink-0">
              <BoardTemplatesCard {...template} />
            </div>
          ))}
          {!isLoadingMore && !isLoading && hasMore ? (
            <div className="h-[1px]" ref={loadMoreRef} />
          ) : null}
          {isLoadingMore && (
            <div className="flex w-full items-center justify-center py-4">
              <LoadingSpinner />
            </div>
          )}
        </div>
      )}
      {selectedTemplate && (
        <BoardTemplateDetails templateId={selectedTemplate} />
      )}
    </div>
  );
};
